package com.tovtalk.ui.screen.onboarding

import androidx.compose.material3.AlertDialog
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.tovtalk.ui.theme.TovTalkTheme
import com.tovtalk.utils.strings.StringProvider

/**
 * Shown when guest-session commit fails after all automatic retries.
 * Offers another manual retry or returns the user to Categories with
 * their selections intact.
 */
@Composable
fun OnboardingCommitErrorDialog(
    errorMessage: String?,
    onRetry: () -> Unit,
    onCancel: () -> Unit,
    modifier: Modifier = Modifier,
) {
    AlertDialog(
        // No-op: scrim tap / back gesture should not silently rewind the user
        // to Categories. They must explicitly choose "נסה שוב" or "ביטול".
        onDismissRequest = {},
        title = {
            Text(
                text = StringProvider.get("onboarding_commit_error_title"),
                style = TovTalkTheme.typography.titleMedium,
                color = TovTalkTheme.colors.textPrimary,
            )
        },
        text = {
            Text(
                text = errorMessage?.takeIf { it.isNotBlank() }
                    ?: StringProvider.get("onboarding_commit_error_body"),
                style = TovTalkTheme.typography.bodyMedium,
                color = TovTalkTheme.colors.textSecondary,
            )
        },
        confirmButton = {
            TextButton(onClick = onRetry) {
                Text(
                    text = StringProvider.get("common_retry"),
                    color = TovTalkTheme.colors.brand,
                )
            }
        },
        dismissButton = {
            TextButton(onClick = onCancel) {
                Text(
                    text = StringProvider.get("common_cancel"),
                    color = TovTalkTheme.colors.textSecondary,
                )
            }
        },
        modifier = modifier,
    )
}
